export const deleteAllCart = () => ({
  type: "@saga/DELETE_ALL_CART",
});
